export default {
  new: 'New',
  confirmed: 'Confirmed',
  partially_delivered: 'Partially Delivered',
  delivered: 'Delivered',
  returned: 'Returned',
  partially_returned: 'Partially Returned',
  completed: 'Completed',
  canceled: 'Canceled'
}
